// extracted by mini-css-extract-plugin
module.exports = {"PanelHeader":"styles_PanelHeader__gzp_6","arrowBottom":"styles_arrowBottom__U_NLC","isActive":"styles_isActive__mwsKQ","orderToggler":"styles_orderToggler__7y5QB"};